import React from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';

import Login from 'pages/Login/Login';
import Home from 'pages/Home/Home';
import Users from 'pages/Users/Users';
import Profile from 'pages/Profile/Profile';
import ResetPassword from 'pages/ResetPassword/ResetPassword';
import NotFound from 'pages/NotFound/NotFound';
import User from 'pages/User/User';
import Section from 'pages/Section/Section';
import Submenu from 'pages/Submenu/Submenu';
import Demo from 'pages/Demo/Demo';
import paths from './paths';
import PrivateRoute from './PrivateRoute/PrivateRoute';

const RouterComponent = () => {

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path={paths.LOGIN} component={Login} />
        <Route exact path={paths.RESET_PASSWORD} component={ResetPassword} />
        <PrivateRoute path={paths.ADD_USER} component={User} />
        <PrivateRoute path={paths.MODIFY_USER} component={User} />
        <PrivateRoute path={paths.USERS} component={Users} />
        <PrivateRoute path={paths.PROFILE} component={Profile} />
        <PrivateRoute path={paths.SECTION} component={Section} />
        <PrivateRoute path={paths.SUBMENU_1} component={Submenu} />
        <PrivateRoute path={paths.SUBMENU_2} component={Submenu} />
        <PrivateRoute path={paths.DEMO} component={Demo} />
        <PrivateRoute path={paths.ROOT} component={Home} />
        <Route component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
};

export default RouterComponent;
